export default __webpack_public_path__ + "static/emobility-circle-c74c3a5a544d5ceb7be5fd723e72fa14.png";